import React from 'react';
import GenericSection from '../components/sections/GenericSection';

const PrivacyPolicy = () => {
  return (
    <GenericSection className="reveal-from-bottom" tag="section">
      <div className="container-xs">
        <h2 className="mt-0">Privacy Policy</h2>
        <p>
          Last updated: April 11, 2026
        </p>
        <p>
          At RedAllianz, accessible from <a href="https://redallianz.com">redallianz.com</a>, one of our main priorities is the privacy of our visitors and users. This Privacy Policy document contains types of information that is collected and recorded by RedAllianz and how we use it. This policy applies to all our services, including our mobile application <strong>Arbeitzeit - Work Logger</strong>.
        </p>

        <h4>Log Files</h4>
        <p>
          RedAllianz follows a standard procedure of using log files. These files log visitors when they use our Services. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the Services, and gathering demographic information.
        </p>

        <h4>Information We Collect</h4>
        <p>
          The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
        </p>
        <p>
          If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
        </p>

        <h4>How We Use Your Information</h4>
        <p>
          We use the information we collect in various ways, including to:
        </p>
        <ul>
          <li>Provide, operate, and maintain our Services</li>
          <li>Improve, personalize, and expand our Services</li>
          <li>Understand and analyze how you use our Services</li>
          <li>Develop new products, services, features, and functionality</li>
          <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the Services, and for marketing and promotional purposes</li>
          <li>Send you emails</li>
          <li>Find and prevent fraud</li>
        </ul>

        <h4>Data Storage and Security</h4>
        <p>
          We take reasonable measures to protect your information from unauthorized access, loss, or misuse. For <strong>Arbeitzeit - Work Logger</strong>, data is primarily stored on your device and synced with our secure cloud servers if you enable synchronization features.
        </p>

        <h4>CCPA Privacy Rights (Do Not Sell My Personal Information)</h4>
        <p>
          Under the CCPA, among other rights, California consumers have the right to request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.
        </p>

        <h4>GDPR Data Protection Rights</h4>
        <p>
          We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
        </p>
        <ul>
          <li>The right to access – You have the right to request copies of your personal data.</li>
          <li>The right to rectification – You have the right to request that we correct any information you believe is inaccurate.</li>
          <li>The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</li>
        </ul>

        <h4>Children's Information</h4>
        <p>
          Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
        </p>
        <p>
          RedAllianz does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
        </p>

        <h4>Contact Us</h4>
        <p>
          If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us at <a href="mailto:hello@redallianz.com">hello@redallianz.com</a>.
        </p>
      </div>
    </GenericSection>
  );
}

export default PrivacyPolicy;
